"use client";

import { useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import UserStatusSection from "./UserStatusSection";
import UserActiveSection from "./UserActiveSection";
import PaperSection from "./PaperSection";
import { toast } from "react-toastify";

import * as myApi from "../Api";
const DashboardContent = () => {

    const [users, setUsers] = useState({});
    const [papers, setPapers] = useState({});

    function fetchData() {
        myApi.get('/admin/dashboard/').then((res) => {
            let result = res.data
            setUsers(result.data.users)
            setPapers(result.data.papers)
        }).catch((err) => {
            toast(err.message, { type: "error" });            
        });
    }

    useEffect(() => {
        if (myApi.getUser().role !== 'admin') {
            window.location.href = "/paper/list/"
        }
        fetchData();
    }, []);

    return (
        <Row>
            <Col md={4}>
                <div className="border-0 rounded-3 mb-4">
                    <UserStatusSection data={users} />
                </div>
            </Col>
            <Col md={8}>
                <Card className="border-0 rounded-3 mb-4">
                    <PaperSection data={papers} />
                </Card>
            </Col>
            <Col md={12}>
                <Card className="border-0 rounded-3 mb-4">
                    <UserActiveSection data={users} />
                </Card>
            </Col>
        </Row>
    );
};

export default DashboardContent;